<template>
    <LoadingButton
        type="primary"
        class="submit-button"
        :disabled="disabled"
        :loading="loading"
        @click="$emit('click')"
        :color-range="getColorRange">
        <slot></slot>
    </LoadingButton>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton'

export default {
    name: 'submit-button',

    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean
        }
    },

    computed: {
        ...mapGetters(['getUserType']),
        getColorRange() {
            if (this.getUserType === 'observer') return ['#3F5CBD', '#1BC8CE']
            return ['#2d3e4f', '#2c6ca3']
        }
    },

    components: {
        LoadingButton
    }
}
</script>

<style lang="scss" scoped>
.el-button.submit-button {
    display: block;
    width: 100%;
    border: none;
    font-weight: 600;
    border-radius: 0;
    background: linear-gradient(101.06deg, #3F5CBD 7.71%, #1BC8CE 126.22%);
}
</style>
